module.exports = "https://img.xiyuyouxi.com/saas/img/close_icon.334241cb.png";